<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['saving_scheme']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-saving size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Saving</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(patient)="data">
                {{ data.item.patient.name }}
              </template>
              <template #cell(patientid)="data">
                {{ data.item.patient.patient_id }}
              </template>
              <template #cell(patientct)="data">
                0{{ data.item.patient.telephone }}
              </template>
              <template #cell(method)="data">
                {{ data.item.method.name }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.patient.patient_id,data.item.saving_date,data.item.saving,data.item.method.id )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.patient.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
       
                  <!-- <span class="total-label">Total Savings:</span>
                  <span class="total-value">{{commas ( totalSavings ) }}</span> -->
                  <div class="mt-3">
      <strong>Total Savings: {{ formatNumber(totalSavings) }}</strong>
    </div>
            </div>
            
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Savings</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-saving" centered title="New Saving" title-class="font-18" hide-footer>
        <form @submit.prevent="addSaving">
          <div class="form-group mb-2">
            <label>Patient's Name</label>
              <multiselect v-model="patient" :options="patients" :custom-label="customLabel" label="name"></multiselect>
            </div>
            <div class="form-group mb-2">
            <label>Saving Amount</label>
            <input v-model="saving" type="number" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Saving Date</label>
            <input v-model="saving_date" type="date" required class="form-control" />
            </div>
            <label>Payment Method</label>
            <multiselect v-model="payment_method" :options="paymentoptions" label="name"></multiselect>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-saving')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-saving" centered title="Edit Saving" title-class="font-14" hide-footer>
        <form @submit.prevent="editSaving">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Patient</label>
            <b-form-select v-model="patient" required :options="patients" class="mb-3 form-control" value-field="patient_id" text-field="name"></b-form-select>
            </div>
            <div class="form-group mb-2">
            <label>Saving Amount</label>
            <input v-model="saving" type="number" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Saving Date</label>
            <input v-model="saving_date" type="date" required class="form-control" />
            </div>
            <label>Payment Method</label>
            <b-form-select v-model="payment_method" :options="paymentoptions" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-saving')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-saving" centered title="Delete Saving " title-class="font-18" hide-footer>
        <form @submit.prevent="removeSaving">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Saving for : <b>{{ patient }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-saving')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { savingComputed, savingMethods,paymentoptionComputed, paymentoptionMethods, patientMethods, patientComputed } from "@/state/helpers";

export default {
  page: {
    title: "View Savings",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Multiselect,Layout,PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "View Savings",
      items: [ {text: "Dashboard",to: "/",}, {text: "View Savings",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'patientid', label: 'Patient ID', visible: true },
          { key: 'patient', label: 'Patient Name', visible: true },
          { key: 'patientct', label: 'Patient', visible: true },
          { key: 'saving', label: 'Saving', visible: true },
          { key: 'method', label: 'Paymethod', visible: true },
          { key: 'saving_date', label: 'Saving Date', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      patient:'',
      saving_date:new Date().toLocaleDateString('fr-CA'),
      saving:'',
      payment_method:'',
    };
  },
  computed: {
    ...savingComputed,
    ...paymentoptionComputed,
    ...patientComputed,
    List() { return this.savings.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.savings.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.savings.length>0) { a=false;} else { a=true;} return a },
    totalSavings() { return this.Items.reduce((total, item) => total + Number(item.saving), 0);},
  },
  mounted() {
    this.fetchPatients();
    this.fetchPaymentoptions();
    this.fetchSavings();
    this.TotalRows = this.savings.length;
    this.isBusy=false;
  },
  methods: {
    ...patientMethods,
    ...savingMethods,
    ...paymentoptionMethods,
    formatNumber(value) {
  
      return value.toLocaleString();
    },
    customLabel ({ patient_id, name, telephone }) {
      return `${patient_id} – ${name} – ${telephone}`
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,patient,saving_date,saving,paymethod){
      this.id=id;
      this.patient=patient;
      this.saving_date=saving_date;
      this.saving=saving;
      this.payment_method=paymethod;
      this.$bvModal.show('edit-saving')
    },
    remove(id,patient){
      this.id=id;
      this.patient=patient;
      this.$bvModal.show('delete-saving')
    },
    async addSaving() { 
      let formData = new FormData();
      formData.append("patient", this.patient.patient_id);
      formData.append("saving_date", this.saving_date);
      formData.append("saving", this.saving);
      formData.append("paymentoption", this.payment_method.id);
      let url = "/addsaving";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchSavings();
          this.$bvModal.hide('new-saving');
          this.patient="";
          this.saving="";
          this.payment_method="";
          this.$toast.success("New Patient Saving Added");
      }
      });
    },
    async editSaving(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("patient", this.patient);
    formData.append("saving_date", this.saving_date);
    formData.append("saving", this.saving);
    formData.append("paymentoption", this.payment_method);
    let url = "/updatesaving";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchSavings();
        this.$bvModal.hide('edit-saving');
        this.patient="";
        this.saving_date="";
        this.saving="";
        this.payment_method="";
        this.$toast.success("Patient Saving Updated");
      }
    });
    },
    async removeSaving() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removesaving";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchSavings();
        this.$bvModal.hide('delete-saving');
        this.$toast.error("Patient Saving Deleted");
      }
    });
    },
  },
};
</script>
<style scoped>
.total-label {
  margin-right: 10px; 
}
.total-value {
  font-weight: bold;
  margin-right: 20px; 
}
</style>